export const UserConfirmActionTypes = {
    ADD_CONFIRMUSER: 'ADD_CONFIRMUSER',
    ADD_BUTTON: "ADD_BUTTON"
};